var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49958 0.281738C4.1776 0.931863 0.761453 4.34801 0.111328 8.66999H2.13997C2.74992 5.45457 5.28416 2.92033 8.49958 2.31038V0.281738ZM11.4996 2.31038V0.281738C15.8216 0.931863 19.2377 4.34801 19.8878 8.66999H17.8592C17.2492 5.45457 14.715 2.92033 11.4996 2.31038ZM17.8592 11.67C17.2492 14.8854 14.715 17.4196 11.4996 18.0296V20.0582C15.8216 19.4081 19.2377 15.992 19.8878 11.67H17.8592ZM8.49958 20.0582V18.0296C5.28416 17.4196 2.74992 14.8854 2.13997 11.67H0.111328C0.761453 15.992 4.1776 19.4081 8.49958 20.0582Z",
    fill: "#A79FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.1699L9 13.1699L14 7.16992",
    stroke: "#A79FBD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLts);
export default __webpack_public_path__ + "static/media/LTS.6fc7c5f74ad9d7710950607efe598b35.svg";
export { ForwardRef as ReactComponent };